<template>
  <div class="page" v-bind:class="`page--${sex}`">
    <div class="medium-margin-vert-80px medium-margin-bottom-0px">
      <div class="margin-vert-40px medium-margin-vert-40px">
        <div class="container">
          <div class="movie-wrapper">
            <div class="video-container">
              <div class="aspect-ratio aspect-ratio--16x9">
                  <iframe class="aspect-ratio--object" width="560" height="315" v-bind:src="`https://www.youtube.com/embed/${videoId}?rel=0`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            <div class="illust large-display-none">
              <img v-bind:src="require(`@/assets/img/pages/result/illust/${imageFile}.png`)" alt class="img-responsive" />
            </div>
          </div>
          <div id="skip"></div>
          <div class="margin-vert-40px medium-margin-vert-40px">
            <div class="reccomend-wrapper">
              <h2 class="reccomend-heading">あなたにぴったりな<span class="display-inline-block">特約は…</span></h2>

              <div class="large-margin-vert-40px">
                <div class="large-margin-vert-40px">
                  <div class="max-width-160px large-max-width-160px center-block">
                    <img v-bind:src="require(`@/assets/img/pages/result/tobira.svg`)" class="img-responsive" alt >
                  </div>
                </div>

                <div class="medium-row-gutter-30px justify-content-center align-items-flex-end ">

                  <div v-for="(contractContract, i) in specialContracts" v-bind:key="i"  class="medium-col-4of12">
                    <div class="tobira-special-contract">
                      <picture>
                        <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/result/mirai/${contractContract}_large.png`)" />
                        <img v-bind:src="require(`@/assets/img/pages/result/mirai/${contractContract}.png`)" class="img-responsive" alt />
                      </picture>
                    </div>
                  </div>

                </div>
              </div>

              <div class="reccomend-divider margin-vert-40px large-margin-vert-40px"></div>

              <div class="large-margin-vert-40px">
                <div class="large-margin-vert-40px">
                  <div class="max-width-170px large-max-width-180px center-block">
                    <img v-bind:src="require(`@/assets/img/pages/result/iryo.svg`)" class="img-responsive" alt />
                  </div>
                </div>

                <div class="medium-row-gutter-30px">
                  <div class="medium-col-4of12">
                    <div class="iryo-special-contract">
                      <picture>
                        <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/result/iryo/01_large.png`)" />
                        <img v-bind:src="require(`@/assets/img/pages/result/iryo/01.png`)" class="img-responsive" alt />
                      </picture>
                    </div>
                  </div>
                  <div v-if="sex==='female'" class="medium-col-4of12">
                    <div class="iryo-special-contract">
                      <picture>
                        <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/result/iryo/02_large.png`)" />
                        <img v-bind:src="require(`@/assets/img/pages/result/iryo/02.png`)" class="img-responsive" alt />
                      </picture>
                    </div>
                  </div>
                  <div v-if="sex==='male'" class="medium-col-4of12">
                    <div class="iryo-special-contract">
                      <picture>
                        <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/result/iryo/04_large.png`)" />
                        <img v-bind:src="require(`@/assets/img/pages/result/iryo/04.png`)" class="img-responsive" alt />
                      </picture>
                    </div>
                  </div>
                  <div class="medium-col-4of12">
                    <div class="iryo-special-contract">
                      <picture>
                        <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/result/iryo/03_large.png`)" />
                        <img v-bind:src="require(`@/assets/img/pages/result/iryo/03.png`)" class="img-responsive" alt />
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul class="note">
              <li class="note-item">
                <span class="note-item-bullet">●</span>本資料は商品の概要や代表事例を示しており、支払事由や制限事項のすべてを記載したものではありません。
              </li>
              <li class="note-item">
                <span class="note-item-bullet">●</span>ご検討にあたっては「保険設計書(契約概要)」「特に重要な事項のお知らせ(注意喚起情報)」「ご契約のしおり-定款・約款」を必ずご確認ください。
              </li>
              <li class="note-item">
                <span class="note-item-bullet">●</span>このページに記載の特約・主契約の名称は略称を記載しています。<br>
                (例)定期保険特約(2022)⇒定期保険特約、医療保険(有配当/2022)⇒医療保険&emsp;など<br>
                正式名称は各商品の「ご契約のしおり－定款・約款」、「ご契約のしおり－普通保険約款および特約」をご確認ください。
              </li>
            </ul>
          </div>

          <div>
            <div class="margin-vert-15px medium-margin-vert-30px">
              <form method="post" action="/request/products/select?pid=s18" accept-charset="UTF-8">
                <input name="pid" type="hidden" value="s18" />
                <input name="tobiraSimulationSex" type="hidden" v-bind:value="getValue('sex')" />
                <input name="tobiraSimulationEra" type="hidden" v-bind:value="getValue('age')" />
                <input
                  name="tobiraSimulationMarried"
                  type="hidden"
                  v-bind:value="getValue('married')"
                />
                <input
                  name="tobiraSimulationChildBearing"
                  type="hidden"
                  v-bind:value="getValue('child')"
                />
                <input
                  name="tobiraSimulationWantChildren"
                  type="hidden"
                  v-bind:value="getValue('hope')"
                />
                <input name="tobiraSimulationResult" type="hidden" v-bind:value="type" />
                <div class="margin-horizon-5px">
                  <button type="submit" class="inquiry-button">
                    資料請求はこちら
                    <svg
                      class="inquiry-button-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 512"
                    >
                      <path
                        fill="currentColor"
                        d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                      />
                    </svg>
                  </button>
                </div>
              </form>
              <p class="text-center margin-vert-5px medium-margin-vert-15px"><a class="alink-top" href="/ad/mirainotobira/">サイトTOPへ戻る</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="illust display-none large-display-block">
      <img
        v-bind:src="require(`@/assets/img/pages/result/illust/${imageFile}_medium.png`)"
        alt
        class="img-responsive display-block"
      />
    </div>
  </div>
</template>
<script>
import Result from "@/model/result";

export default {
  data() {
    return {
      id: null,
      publicPath: process.env.BASE_URL,
    };
  },
  components: {},
  computed: {
    imageFile: function () {
      return Result.getImageFileById(this.id);
    },
    videoId: function () {
      return Result.getVideoIdById(this.id);
    },
    type: function () {
      return Result.getTypeById(this.id);
    },
    specialContracts: function () {
      return Result.getSpecialContractsById(this.id);
    },
    sex: function () {
      return Result.getSexById(this.id);
    },
  },
  methods: {
    getValue(name) {
      if (!this.answers) {
        return;
      }
      for (let i = 0; i < this.answers.length; i++) {
        if (name === this.answers[i].answer.name) {
          return this.answers[i].answer.value;
        }
      }
      return "";
    },
  },
  mounted() {},
  props: {
    answers: {
      type: Array,
    },
    skip: {
      type: Boolean,
    },
  },
  beforeMount() {
    this.id = this.$route.params.id;
  },
};
</script>
<style lang="scss" scoped>
/*
ページ
*/
.page {
  min-height: calc(100vh - 25px);
  overflow: hidden;
  position: relative;
  background-size: 100% auto;
  background-repeat: no-repeat, repeat;
  @media (min-width: 992px) {
    min-height: 0;
    background-size: 100% auto;
    background-repeat: no-repeat, repeat;
  }
}
.page.page--female{
  background-image: url("../assets/img/pages/result/bg_upper_female.png"), url("../assets/img/pages/result/bg.png");
  @media (min-width: 992px) {
    background-image: url("../assets/img/pages/result/bg_medium_upper_female.png"), url("../assets/img/pages/result/bg_medium.png");
  }
}
.page.page--male{
  background-image: url("../assets/img/pages/result/bg_upper_male.png"), url("../assets/img/pages/result/bg.png");
  @media (min-width: 992px) {
    background-image: url("../assets/img/pages/result/bg_medium_upper_male.png"), url("../assets/img/pages/result/bg_medium.png");
  }
}

/*
動画
*/
.movie-wrapper {
  position: relative;
  margin: 160px auto 0;
  @media (min-width: 992px) {
    margin: 60px auto 60px;
    max-width: 720px;
  }
}
.video-container {
  border-radius: 4px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.1);
  @media (min-width: 992px) {
    border-radius: 6px;
    box-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.1);
  }
}
//人物レイヤーの上に表示させるため
.video-container {
  position: relative;
  z-index: 1;
}

/*
イラスト
*/
@media (min-width: 992px) {
  .illust {
    position: absolute;
    top: 10%;
    right: 0;
  }
}
@media (max-width: 991px) {
  .illust {
    width: 192px;
    position: absolute;
    top: -144px;
    right: -24px;
  }
}

/*
特約
*/
.reccomend-wrapper {
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.1), -1px -1px 2px 0 rgba(0, 0, 0, 0.03);
  padding: 30px 20px;
  margin: 15px 0;
  @media (min-width: 992px) {
    position: relative;
    z-index: 1;
    border-radius: 8px;
    box-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.1), -1px -1px 2px 0 rgba(0, 0, 0, 0.03);
    padding: 60px 50px;
    margin: 15px 90px;
  }
}
.reccomend-heading {
  font-size: 22px;
  margin: 0 0 22px;
  color: #e67700;
  text-align: center;
  line-height: 1.5;
  @media (min-width: 992px) {
    font-size: 35px;
    margin: 0 0 50px;
    letter-spacing: 0.05em;
  }
}
.reccomend-divider {
  height: 0;
  border-bottom: dotted 2px #b4b2b3;
}

.tobira-special-contract,
.iryo-special-contract {
  max-width: 230px;
  margin: 20px auto;
  @media (min-width: 992px) {
    max-width: none;
    margin: 0px auto;
  }
}
.tobira-special-contract:last-child,
.iryo-special-contract:last-child {
  margin-bottom: 0;
}

/*
注釈
*/
.note {
  list-style-type: none;
  font-size: 11px;
  font-family: "Yu Gothic", YuGothic, "メイリオ", Meiryo, "sans-serif";
  color: #343434;
  font-weight: normal;
  @media (min-width: 992px) {
    margin: 0px 90px;
    font-size: 14px;
  }
}
.note-item {
  margin: 0.5em 0;
  padding-left: 1.5em;
  line-height: 1.5;
}
.note-item-bullet {
  float: left;
  width: 1.5em;
  text-align: center;
  margin-left: -1.5em;
}

/*
資料請求ボタン
*/
.inquiry-button {
  background-color: #c6051c;
  color: #ffffff;
  display: block;
  margin: 0 auto;
  padding: 12px;
  font-size: 15px;
  text-decoration: none;
  border-radius: 6px;
  text-align: center;
  border: solid 2px #c6051c;
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.2);
  position: relative;
  max-width: 320px;
  width: 100%;
  cursor: pointer;
  @media (min-width: 992px) {
    font-size: 16px;
    max-width: 420px;
    padding: 16px;
  }
}
.inquiry-button:hover {
  background-color: #ffffff;
  color: #c6051c;
}
.inquiry-button-icon {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 10px;
  width: 18px;
  height: 18px;
}

.alink-top{
  text-align: center;
  color: inherit;
  font-size: 12px;
  @media (min-width: 992px) {
    font-size: 14px;
  }
}
/*
登録番号
*/
// .registration-number{
//   position: absolute;
//   bottom: 0px;
//   right: 0px;
//   margin: 5px 15px;
//   z-index: 1;
//   font-size: 11px;
//   color: #333333;
//   font-weight: normal;
//   text-align: right;
//   font-family: sans-serif;
//   @media (min-width: 992px) {
//     display: none;
//   }
// }

</style>